export const PALETTE_CUSTOM_STYLE_PROPERTY = 'color-palette';

export const DEFAULT_PALETTE_MAX_COLORS = 5;

/** Excludes near-white hex colors from the derived default palette. */
export const LIGHT_COLOR_HEX_PATTERN = /f[a-f]{3}/;
